import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material'
import { useDrawerStore } from '../../../store/useDrawerStore'

import { ChevronLeft } from '@mui/icons-material'
import TuneIcon from '@mui/icons-material/Tune'
import { useFormContext } from '../../../context/form'

const DashboardAppBar = () => {
  const { productsList, isFetchingProducts, isFetchingLenders } =
    useFormContext()

  const theme = useTheme()
  const { setDrawerToggle, isDrawerOpen } = useDrawerStore()

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        zIndex: 1,
      }}
    >
      <Toolbar>
        {/*@ts-ignore*/}
        {theme?.custom?.appConfig?.showMenuBar === 'Yes' ? (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {
              setDrawerToggle()
            }}
            sx={{
              marginRight: '36px',
              mr: 2,
            }}
            disableRipple
          >
            {isDrawerOpen ? (
              <ChevronLeft sx={{ color: 'white' }} />
            ) : (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<TuneIcon sx={{ color: 'white' }} />}
                sx={{
                  color: `white !important`,
                  backgroundColor: `${theme?.palette?.secondary?.main}`,
                  border: `1px solid ${theme?.palette?.primary?.main}`,
                  '&:hover': {
                    border: `1px solid ${theme?.palette?.secondary?.main} !important`,
                    borderColor: `${theme?.palette?.secondary?.main} !important`,
                    background: 'white',
                    '& .button-text': {
                      color: `${theme?.palette?.secondary?.main} !important`,
                    },
                    '& .MuiButton-startIcon > *': {
                      color: `${theme?.palette?.secondary?.main} !important`,
                    },
                  },
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
              >
                <Typography
                  className="button-text"
                  variant="body1"
                  component="span"
                  textTransform="capitalize"
                  fontSize={{
                    md: '14px !important',
                    xs: '12px !important',
                  }}
                  sx={{
                    color: `white !important`,
                    '&:hover': {
                      color: `${theme?.palette?.secondary?.main} !important`,
                    },
                  }}
                >
                  Filters
                </Typography>
              </Button>
            )}
          </IconButton>
        ) : null}
        {!isFetchingProducts && !isFetchingLenders && (
          <Typography
            variant="h4"
            color="white"
            sx={{
              color: `white !important`,
              marginTop: "0 !important",
              marginBottom: "0 !important",
              fontSize: `20px !important`,
              fontWeight: `500 !important`,
              lineHeight: 1.235,
              '@media (max-width: 600px)': {
                fontSize: `16px !important`,
              },
              '@media (min-width: 900px)': {
                marginLeft: isDrawerOpen ? "290px !important" : "215px !important",
              },
            }}
          >
            {productsList.length === 3000 ? '3000+' : productsList.length || 0}{' '}
            deals found
          </Typography>
        )}
        {/* <img
          src={theme?.custom?.logo}
          alt="company logo"
          style={{
            marginRight: '10px',
            maxHeight: '45px',
            maxWidth: '120px',
            display: isMatchDownMd ? 'none' : 'block',
          }}
        />
        <IconButton
          edge="start"
          color="inherit"
          arial-label="open drawer"
          onClick={setDrawerToggle}
          sx={{
            marginRight: '36px',
            mr: 2,
            display: { md: 'none' },
          }}
        >
          <Menu sx={{ color: 'white' }} />
        </IconButton> */}
      </Toolbar>
    </AppBar>
  )
}

export default DashboardAppBar
